__turbopack_context__.v({
  "root": "PlasmicLogo-module__QjGp4G__root",
  "rootgrayscale": "PlasmicLogo-module__QjGp4G__rootgrayscale",
  "rootgrayscale_product_myCme": "PlasmicLogo-module__QjGp4G__rootgrayscale_product_myCme",
  "rootgrayscale_product_myGme": "PlasmicLogo-module__QjGp4G__rootgrayscale_product_myGme",
  "rootinteractable": "PlasmicLogo-module__QjGp4G__rootinteractable",
  "rootproduct_myCme": "PlasmicLogo-module__QjGp4G__rootproduct_myCme",
  "rootproduct_myEvaluations_grayscale": "PlasmicLogo-module__QjGp4G__rootproduct_myEvaluations_grayscale",
  "rootproduct_myGme": "PlasmicLogo-module__QjGp4G__rootproduct_myGme",
});
